import gradientColor from "../../utility/gradientColor";
import "./Score.scss"

const isDarkThemeActive = () => {
  if (typeof document === "undefined") return false;

  const themeAttribute = document.documentElement?.getAttribute("data-theme");
  if (themeAttribute === "dark") return true;
  if (themeAttribute === "light") return false;

  if (typeof window !== "undefined" && typeof window.matchMedia === "function") {
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  }

  return false;
};

const Score = ({ score }) => {
  const darkModeActive = isDarkThemeActive();

  return (
    <div
      className="score"
      style={{ background: gradientColor(score, { darkMode: darkModeActive }) }}
    >
      {score}%
    </div>
  );
}



export default Score;
